{
  "page": {
    "title": "Snipe-Benachrichtigungen",
    "subtitle": "Erhalte Discord-DMs, wenn Gegenstände, Haustiere oder der WoW-Token, die du beobachtest, im Auktionshaus unter deinem Zielpreis erscheinen."
  },
  "discordRequired": {
    "title": "Discord erforderlich",
    "description": "Du musst dein Discord-Konto verknüpfen, bevor du Snipe-Benachrichtigungen konfigurieren kannst. Benachrichtigungen werden als Discord-DMs gesendet.",
    "linkButton": "Zu den Einstellungen, um Discord zu verknüpfen"
  },
  "loading": "Wird geladen...",
  "notifications": {
    "title": "Snipe-Benachrichtigungen",
    "description": "Erhalte Benachrichtigungen, wenn beobachtete Gegenstände oder Haustiere unter deinem Zielpreis gefunden werden."
  },
  "alertStyle": {
    "title": "Benachrichtigungsstil",
    "subtitle": "Wähle, wie Discord-Benachrichtigungen angezeigt werden.",
    "compact": "Kompakt",
    "compactDescription": "Nur Text, keine Vorschaubilder. Mehr Benachrichtigungen pro Nachricht.",
    "detailed": "Detailliert",
    "detailedDescription": "Ansprechende Einbettungen mit Gegenstandsvorschaubildern. Eine Einbettung pro Gegenstand."
  },
  "cooldown": {
    "title": "Benachrichtigungs-Cooldown",
    "subtitle": "Wie viele Auktionshaus-Aktualisierungszyklen (je ca. 1 Stunde) übersprungen werden, bevor für dasselbe Auktionsangebot erneut benachrichtigt wird. 0 = bei jeder Aktualisierung benachrichtigen.",
    "cycles": "Zyklen",
    "save": "Speichern",
    "saving": "Speichern..."
  },
  "realms": {
    "title": "Zu überwachende Server",
    "subtitle": "Wähle, welche {{region}}-Server du auf Snipe-Möglichkeiten überwachen möchtest.",
    "placeholder": "Zu überwachende Server auswählen",
    "removeRussian": "Alle russischen Server entfernen",
    "saveButton": "Server speichern",
    "savingButton": "Wird gespeichert..."
  },
  "addEdit": {
    "addTitle": "Snipe-{{type}} hinzufügen",
    "editTitle": "Snipe-{{type}} bearbeiten",
    "typeLabel": "Typ",
    "typeItem": "Gegenstand",
    "typePet": "Haustier",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Gegenstandsname",
    "petNameLabel": "Haustiername oder ID",
    "tokenLabel": "Token",
    "searchPlaceholder": "Nach einem Gegenstand suchen...",
    "petPlaceholder": "Haustier-ID eingeben (z.B. 3390) oder nach Name suchen...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9.999.999g 99s",
    "targetPriceLabel": "Zielpreis",
    "pricePlaceholder": "z.B. 500g oder 500g 50s",
    "ilvlMinLabel": "Min ilvl",
    "ilvlMaxLabel": "Max ilvl",
    "optional": "(opt)",
    "sockets": "Sockel",
    "secondaryStats": "Sekundäre Attribute",
    "secondaryStatsHint": "(optional, bis zu 2 auswählen)",
    "statCrit": "Krit.",
    "statHaste": "Hast",
    "statVersatility": "Vielseitigkeit",
    "statMastery": "Meisterschaft",
    "noItemsFound": "Keine Gegenstände gefunden",
    "noPetsFound": "Keine Haustiere gefunden",
    "anyItem": "Beliebiger Gegenstand",
    "addButton": "{{type}} hinzufügen",
    "updateButton": "{{type}} aktualisieren",
    "addTokenButton": "Token-Benachrichtigung hinzufügen",
    "updateTokenButton": "Token-Benachrichtigung aktualisieren",
    "cancelEdit": "Bearbeitung abbrechen",
    "remove": "Entfernen",
    "nounItem": "Gegenstand",
    "nounPet": "Haustier",
    "categoryLabel": "Kategorie",
    "statSpeed": "Tempo",
    "statLeech": "Lebensraub",
    "statAvoidance": "Vermeidung"
  },
  "importExport": {
    "importButton": "{{label}} JSON importieren",
    "importingButton": "Wird importiert...",
    "exportIlvlButton": "ilvl-Gegenstände JSON exportieren",
    "exportButton": "{{label}} JSON exportieren",
    "clearAllButton": "Alle {{label}} löschen ({{count}})",
    "pasteHint": "Tip: Drücke Strg+V (oder Cmd+V auf dem Mac) irgendwo auf dieser Seite, um eine JSON-Datei direkt einzufügen und zu importieren.",
    "clearAllTitle": "Alle {{label}} entfernen",
    "clearAllConfirmButton": "Alle entfernen"
  },
  "tabs": {
    "items": "Gegenstände",
    "ilvlItems": "ilvl-Gegenstände",
    "pets": "Haustiere",
    "token": "WoW-Token"
  },
  "table": {
    "filterPlaceholder": "Nach Gegenstandsname oder ID filtern...",
    "countAll": "{{count}} ilvl-Regel(n)",
    "countFiltered": "{{filtered}} von {{total}} ilvl-Regeln",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} von {{total}} {{noun}}",
    "colItems": "Gegenstände",
    "colIlvl": "ilvl",
    "colStats": "Stats",
    "colBuyout": "Sofortkauf",
    "colActions": "Aktionen",
    "colTargetPrice": "Zielpreis",
    "editButton": "Bearbeiten",
    "duplicateButton": "Duplizieren",
    "deleteButton": "Löschen",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Suche oben nach einem Gegenstand oder importiere eine JSON-Datei, um zu beginnen.",
    "emptyHintPets": "Gib oben eine Haustier-ID ein oder importiere eine JSON-Datei, um zu beginnen.",
    "emptyHintToken": "Lege oben einen Zielpreis fest, um benachrichtigt zu werden, wenn die WoW-Marke darunter fällt.",
    "emptyHintIlvl": "Lege oben Gegenstandsstufen-Grenzen fest oder importiere eine JSON-Datei, um zu beginnen.",
    "nounItems": "Gegenstände",
    "nounPets": "Haustiere",
    "nounToken": "Token-Alarm",
    "nounIlvl": "ilvl-Regel(n)",
    "loadingName": "Lädt...",
    "colCategory": "Kategorie",
    "percentLoaded": "{{percent}}% geladen",
    "editPrice": "Preis bearbeiten",
    "inlineEditHint": "Zum Bearbeiten klicken — Enter speichert, Esc bricht ab"
  },
  "personalConfig": {
    "title": "Persönliche Filter-Einstellungen",
    "subtitle": "Passe die Filter unten an, um deine Standardeinstellungen festzulegen. Diese werden automatisch angewendet, wenn du die Auktionstools verwendest.",
    "tip": "💡 Tipp: Stelle deine Filter wie gewünscht ein und klicke dann auf \"Als Standard speichern\", um diese als dauerhafte Einstellungen zu übernehmen.",
    "livePreviewTitle": "Live-Filter-Vorschau",
    "livePreviewSubtitle": "Dies sind die tatsächlichen Filter aus dem Auktions-Tool. Lege deine Standards nach Bedarf fest:",
    "saveButton": "Filterstandards speichern",
    "resetToSavedButton": "🔄 Zu meinen gespeicherten Standards zurücksetzen",
    "resetToSystemButton": "⚙️ Auf Default Werte zurücksetzen",
    "needHelp": "Brauchst du Hilfe mit der Konfiguration? Tritt unserem Discord bei",
    "dashboardSection": "Dashboard-Möglichkeiten-Filter",
    "dashboardSectionSubtitle": "Lege den Sofortkauf-Preisbereich für Artikel im Top-Möglichkeiten-Widget des Dashboards fest.",
    "dashboardBuyoutMin": "Min. Sofortkauf (Gold)",
    "dashboardBuyoutMax": "Max. Sofortkauf (Gold)",
    "dashboardBuyoutMaxHint": "Auf 0 setzen für kein Maximum",
    "dashboardSaveButton": "Dashboard-Konfiguration speichern",
    "itemMatchingSection": "Artikel-Schlüssel-Einstellungen",
    "itemMatchingSectionSubtitle": "Steuere, wie Artikelvarianten bei der Berechnung von Handelsopportunitäten abgeglichen werden.",
    "ignoreStatsBeforeExpansion": "Sekundärwerte ignorieren vor dieser Erweiterung",
    "ignoreStatsBeforeExpansionHint": "Artikel aus Erweiterungen vor der ausgewählten werden unabhängig von ihrem Sekundärwert-Roll als identisch behandelt. Nützlich für alte Legacy-Artikel, bei denen Wertunterschiede keinen Einfluss auf den Handelswert haben.",
    "ignoreStatsNone": "Keine (deaktiviert)",
    "itemMatchingSaveButton": "Artikel-Einstellungen speichern"
  },
  "inventoryAnalysis": {
    "premiumRequired": "Du benötigst ein aktives Premium-Abonnement, um das Tool zu nutzen!",
    "subscriptionRequired": "Du benötigst ein aktives Abonnement, um das Tool zu nutzen!",
    "pasteCSVFirst": "Bitte füge zuerst deine Inventar-CSV-Daten ein.",
    "csvPasted": "Inventar-CSV eingefügt.",
    "pasteHint": "Tipp: Drücke Strg+V (oder Cmd+V auf dem Mac) irgendwo auf dieser Seite, um dein Inventar-CSV direkt einzufügen.",
    "noValidItems": "Keine gültigen Gegenstände in den CSV-Daten gefunden. Überprüfe das Format.",
    "analysisComplete": "Analyse abgeschlossen! {{opportunities}} Verkaufsmöglichkeiten für {{items}} Inventargegenstände gefunden.",
    "analysisFailed": "Inventaranalyse fehlgeschlagen. Bitte erneut versuchen.",
    "title": "Inventaranalyse",
    "description": "Füge den CSV Export deines Spielinventars unten ein. Wir analysieren jeden Gegenstand über alle verfügbaren Server, um die besten Verkaufsmöglichkeiten zu finden.",
    "addonInstall": "Installiere das Addon von",
    "addonInstallHere": "hier",
    "csvFormatTitle": "Erwartetes CSV-Format",
    "csvFormatNote": "Semikolon-getrennt. BonusIDs sind durch Doppelpunkte getrennt (z.B.",
    "csvModifiersNote": "). Modifikatoren verwenden",
    "csvModifiersFormat": "typ=wert",
    "csvModifiersExample": "Format (z.B.",
    "sellingRealmsTitle": "Verkaufs-Server für Inventar",
    "suggestedDropships": "Vorgeschlagene Dropships",
    "inventoryDataLabel": "Inventardaten",
    "itemsDetected": "{{count}} Gegenstand erkannt",
    "itemsDetectedPlural": "{{count}} Gegenstände erkannt",
    "uploadFile": "Datei hochladen",
    "analyzeButton": "{{count}} Gegenstände analysieren",
    "analyzeInventoryButton": "Inventar analysieren",
    "clearButton": "Löschen",
    "backToInput": "Zurück zur Inventareingabe",
    "noOpportunities": "Keine Verkaufsmöglichkeiten für deine Inventargegenstände gefunden.",
    "noOpportunitiesReason": "Dies kann passieren, wenn die Gegenstände keine TSM-Marktdaten haben oder nicht handelbar sind.",
    "tryAgain": "Erneut versuchen",
    "exportCSV": "Für FlipQueue exportieren"
  },
  "realmConfig": {
    "setupGuideLink": "Hier klicken für die Anleitung zur Einrichtung des Tools",
    "selectRegion": "Aktuelle Region auswählen",
    "updateBuyingRealms": "Kauf-Server für {{region}} aktualisieren ({{selected}} von {{total}})",
    "updateSellingRealms": "Verkaufs-Server für {{region}} aktualisieren ({{selected}} von {{max}})",
    "sellingRealmLimitTooltip": "Als Abonnent mit einem {{type}}-Abonnement kannst du nur {{max}} Verkaufs-Server auswählen.",
    "addAllToBuying": "Alle Server zu Kauf-Server hinzufügen",
    "removeAllFromBuying": "Alle Server aus Kauf-Server entfernen",
    "removeRussianFromBuying": "Alle russischen Server aus Kauf-Server entfernen",
    "addAllToSelling": "Alle Server zu Verkaufs-Server hinzufügen",
    "removeAllFromSelling": "Alle Server aus Verkaufs-Server entfernen",
    "removeRussianFromSelling": "Alle russischen Server aus Verkaufs-Server entfernen",
    "wowAccountsTitle": "WoW-Konten",
    "addAccount": "Konto hinzufügen",
    "accountNamePlaceholder": "Kontoname (z.B. WoW2)",
    "accountNameRequired": "Kontoname ist erforderlich",
    "addAccountFailed": "Konto konnte nicht hinzugefügt werden",
    "deleteAccountDefault": "Standardkonto kann nicht gelöscht werden",
    "deleteAccountConfirm": "Bist du sicher? Dieses Konto wird aus allen Server-Zuweisungen entfernt.",
    "deleteAccountFailed": "Konto konnte nicht gelöscht werden",
    "updateAccountFailed": "Kontoname konnte nicht aktualisiert werden",
    "assignRealmsLabel": "Server Konten zuweisen (ein Server kann mehreren Konten zugeordnet sein):",
    "selectAll": "Alle auswählen",
    "deselectAll": "Alle abwählen",
    "noRealmsSelected": "Keine Server ausgewählt",
    "addMoreAccounts": "Weitere Konten hinzufügen, um Server verschiedenen WoW-Konten zuzuweisen.",
    "saveButton": "Alle Daten speichern",
    "missingAccountsError": "Bitte weise jedem Server mindestens ein Konto zu. Fehlend: {{Server}}",
    "discordQuestion": "Noch Fragen? Tritt unserem Discord bei",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "TSM-Listengenerator",
    "saveButtonDirty": "Änderungen speichern •",
    "saveSettingsFailed": "Einstellungen konnten nicht gespeichert werden",
    "unsavedTitle": "Ungespeicherte Änderungen",
    "unsavedLeaveMessage": "Du hast ungespeicherte Realm-Einstellungen. Wenn du diese Seite verlässt, gehen deine Änderungen verloren.",
    "unsavedLeaveConfirm": "Ohne Speichern verlassen",
    "unsavedStay": "Auf der Seite bleiben",
    "saveBeforeNavTitle": "Änderungen speichern?",
    "saveBeforeNavMessage": "Deine Realm-Auswahl enthält ungespeicherte Änderungen. Speichere sie, damit das Tool deine neuen Einstellungen verwendet.",
    "saveAndContinue": "Speichern & fortfahren",
    "deleteAccountTitle": "WoW-Account löschen",
    "deleteAccountMessage": "Account „{{name}}“ löschen? Er wird aus allen Realm-Zuweisungen entfernt.",
    "deleteAccountConfirmButton": "Löschen",
    "renameAccountAria": "Account {{name}} umbenennen",
    "deleteAccountAria": "Account {{name}} löschen",
    "confirmRenameAria": "Accountnamen speichern",
    "cancelRenameAria": "Umbenennen abbrechen",
    "confirmAddAria": "Account hinzufügen",
    "cancelAddAria": "Hinzufügen abbrechen"
  },
  "tsmProfile": {
    "title": "TSM-Profil-Einrichtungsanleitung",
    "realmPriceAnalysis": "Server-Preisanalyse",
    "minimumPriceOperation": "Mindestpreis-Operation",
    "maximumPriceOperation": "Höchstpreis-Operation",
    "normalPriceOperation": "Normalpreis-Operation",
    "copyButton": "Kopieren",
    "copiedSuccess": "TSM {{operation}} Preis-Operation in die Zwischenablage kopiert!",
    "copyFailed": "In die Zwischenablage kopieren fehlgeschlagen"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "Du benötigst ein aktives Abonnement, um das Tool zu nutzen!",
    "watchVideoGuide": "Video-Guide ansehen",
    "copyTSMString": "TSM-String kopieren",
    "copyTSMFailed": "TSM-String konnte nicht in die Zwischenablage kopiert werden",
    "videoGuideTitle": "TSM-Listengenerator Video-Guide",
    "emptyTitle": "Keine Auktionsdaten gefunden",
    "emptyDescription": "Für deine konfigurierten Realms wurden keine Auktionsdaten gefunden. Überprüfe deine Realm-Konfiguration oder versuche es nach der nächsten Aktualisierung des Auktionshauses erneut.",
    "emptyConfigureButton": "Realms konfigurieren",
    "emptyRetryButton": "Erneut versuchen"
  },
  "realmStats": {
    "subscriptionRequired": "Du benötigst ein aktives Abonnement, um das Tool zu nutzen!",
    "overallStatistics": "Gesamtstatistiken",
    "realmPriceAnalysis": "Server-Preisanalyse",
    "watchVideoGuide": "Videoanleitung ansehen",
    "noData": "Keine Server-Daten verfügbar",
    "legend": "Legende",
    "legendCheap": "Eher günstig (<{{ratio}})",
    "legendNormal": "Um den Normalwert ({{min}}-{{max}})",
    "legendExpensive": "Deutlich teurer (>{{ratio}})",
    "tooltipCheap": "Das bedeutet, dass Gegenstände generell näher am regionalen Verkaufsdurchschnitt liegen. Hier ist es also eher günstig zu kaufen, aber nicht so gut zum Verkaufen.",
    "tooltipNormal": "Das bedeutet, dass Gegenstände gemischt in Bezug auf den regionalen Verkaufsdurchschnitt sind. Es kann gut sein zum Kaufen und Verkaufen.",
    "tooltipExpensive": "Das bedeutet, dass Gegenstände generell deutlich über dem regionalen Verkaufsdurchschnitt liegen. Hier ist es eher teuer zu kaufen, aber möglicherweise gut zum Verkaufen.",
    "colRealmName": "Server-Name",
    "colPopulation": "Bevölkerung",
    "colAuctions": "Auktionen",
    "colPriceRatio": "Preisverhältnis",
    "colCheaper": "Günstiger",
    "colExpensive": "Teurer",
    "colPercentCheaper": "% Günstiger",
    "colPercentExpensive": "% Teurer",
    "colPercentEqual": "% Gleich",
    "totalRealms": "Server gesamt",
    "totalAuctions": "Auktionen gesamt",
    "avgPriceRatio": "Durchschn. Preisverhältnis",
    "cheaperThanRegion": "Günstiger als Region",
    "totalAuctionsHistory": "Auktionen-Verlauf gesamt",
    "avgPriceRatioHistory": "Durchschn. Preisverhältnis-Verlauf",
    "percentCheaperHistory": "% Günstiger-Verlauf",
    "auctionsHistory": "{{Server}} - Auktionen-Verlauf",
    "priceRatioHistory": "{{Server}} - Preisverhältnis-Verlauf",
    "cheaperCountHistory": "{{Server}} - Günstiger-Anzahl-Verlauf",
    "expensiveCountHistory": "{{Server}} - Teurer-Anzahl-Verlauf",
    "percentCheaperRealm": "{{Server}} - % Günstiger-Verlauf",
    "percentExpensiveRealm": "{{Server}} - % Teurer-Verlauf",
    "percentEqualRealm": "{{Server}} - % Gleich-Verlauf",
    "videoTitle": "Videoanleitung zum Server-Statistik-Tool"
  },
  "tsmDataTable": {
    "colItemName": "Gegenstandsname",
    "colCategory": "Kategorie",
    "colExpansion": "Erweiterung",
    "colSellRate": "Verkaufsrate",
    "colSaleAvg": "Verkaufsdurchschnitt",
    "colRegionMarketValue": "Regionaler Marktwert",
    "colRegionHistorical": "Regionaler Verlauf",
    "clickToCopy": "Klicken zum Kopieren: {{name}}",
    "tooltipSaleAvg": "Durchschnittspreis, zu dem ein Gegenstand in den letzten 60 Tagen verkauft wurde",
    "tooltipMarketValue": "Durchschnittspreis, zu dem ein Gegenstand in den letzten 14 Tagen über alle Server in deiner Region angeboten wurde",
    "tooltipHistorical": "Durchschnittspreis, zu dem ein Gegenstand in den letzten 60 Tagen über alle Server in deiner Region angeboten wurde"
  },
  "import": {
    "confirmTitle": "Import bestätigen",
    "confirmMessage": "{{count}} Einträge in die Liste „{{tab}}“ importieren?",
    "confirmMessageCategory": "{{count}} Einträge in die Liste „{{tab}}“ importieren (Kategorie: {{category}})?",
    "confirmButton": "Importieren"
  }
}
